import { useHistory } from 'react-router'
import { useState, useContext, useEffect } from 'react'
import { Context } from '../../../context/Provider'
import { convertToNumber } from '../../../utilities/convertToNumber'

import {
	getFloaterPreFilled,
	updateFloaterValues,
} from '../../../utilities/convertingDeclaredToFloater'
import { Divider, Alert, MainContainer, Space, theme, Input, Modal, Text } from 'verak-ui'
import { SelectedDisclosureMethod, FloaterValuesError } from '../../../components/SharedComponents'
import { FloaterDeclarationError } from '../Modals'

const FloaterDeclaration2 = ({ toggleFloaterDec, propertyType, levelIndex, currentLocationId }) => {
	const [state, dispatch] = useContext(Context)
	const [MaxValueAllLoc, setMaxValueAllLoc] = useState('')
	const [MaxValueOneLoc, setMaxValueOneLoc] = useState('')
	const [error, setError] = useState(false)
	const [modalState, setModalState] = useState(false)

	const returnPath = state?.sqs?.returnPath || '/property-risk/sum-insured'

	const RiskLocations = state.quote?.RiskLocations

	const modalContent = (
		<FloaterDeclarationError
			propertyType={propertyType}
			levelIndex={levelIndex}
			currentLocationId={currentLocationId}
		/>
	)

	const checkForValues = () => {
		if (MaxValueAllLoc && MaxValueOneLoc) {
			return false
		} else {
			return true
		}
	}
	const disableProceed = checkForValues()

	let history = useHistory()

	// handles dynamic prefilling of values
	useEffect(() => {
		const values = getFloaterPreFilled(RiskLocations)
		setMaxValueAllLoc(values.total)
		setMaxValueOneLoc(values.maxOneLoc)
	}, [])

	const proceed = async () => {
		const changeFloaterValues = (ID, propertyType, levelIndex, Stock) => {
			const toReturn = new Promise((resolve, reject) => {
				dispatch({
					type: 'MOVE_TO_LOCATION',
					data: {
						locationId: ID,
					},
				})
				dispatch({
					type: 'UPDATE_RISK_LOCATION_DETAILS',
					propertyType: propertyType,
					levelIndex: levelIndex,
					data: {
						Stock,
					},
				})
				dispatch({
					type: 'SAVE_LOCATION_CHANGES_AND_NAVIGATE',
				})

				resolve()
			})
			return toReturn
		}

		if (parseFloat(MaxValueOneLoc) > parseFloat(MaxValueAllLoc)) {
			setError(true)
		} else if (parseFloat(MaxValueAllLoc) < 20000000 || parseFloat(MaxValueOneLoc) < 2500000) {
			setModalState(true)
		} else {
			await new Promise((resolve, reject) => {
				dispatch({
					type: 'SET_STOCK_VALUE',
					data: {
						MaxValueAllLoc: MaxValueAllLoc || '',
						MaxValueOneLoc: MaxValueOneLoc || '',
					},
				})
				dispatch({
					type: 'SET_NUMSTOCK_AND_DISCLOSURE_METHOD',
					data: {
						NumStock: 2,
						StockDisclosureMethod: 'FLOATER_DECLARATION',
					},
				})

				resolve()
			})

			// dispatching values of open & covered in %
			const data = updateFloaterValues(RiskLocations)
			const promiseList = data.map(el =>
				changeFloaterValues(el.ID, el.propertyType, el.levelIndex, el.Stock)
			)
			await Promise.all(promiseList)

			// resets state.location to the previous value it arrived from
			await new Promise((resolve, reject) => {
				dispatch({
					type: 'MOVE_TO_LOCATION',
					data: {
						locationId: currentLocationId,
					},
				})
				resolve()
			})

			history.replace({
				pathname: returnPath,
				state: {
					propertyType: propertyType,
					levelIndex: levelIndex,
				},
			})
		}
	}

	const handleChangeInMaxValueAllLoc = e => {
		const numValue = convertToNumber(e.target.value)
		setMaxValueAllLoc(numValue)
	}
	const handleChangeInMaxValueOneLoc = e => {
		const numValue = convertToNumber(e.target.value)
		setMaxValueOneLoc(numValue)
	}

	let renderStocSumInsAlert = null

	if (parseInt(MaxValueAllLoc) > 500000000) {
		renderStocSumInsAlert = (
			<>
				<Space y={1} />
				<Alert
					bgColor={theme.colors.secondaryLightRed}
					iconName="warningTriangleSm"
					infoIconColor={theme.colors.red}
					titleColor={theme.colors.red}
					title="Important Notice"
				>
					<Space y={0.5} />
					<Text type="body2" style={{ marginLeft: '2rem' }}>
						The Sum Insured has exceeded ₹50 crore - you may continue with the quotation. However,
						you will not get an immediate quote - the Sales Manager will need to help you.
					</Text>
				</Alert>
			</>
		)
	}

	return (
		<MainContainer
			header="Stock details"
			top={2.5}
			leftOnClick={() => toggleFloaterDec(0)}
			rightOnClick={proceed}
			rightDisabled={disableProceed}
		>
			<SelectedDisclosureMethod method="Floater Declaration" />
			<Input
				label="Total value of stock:"
				labelStyle={textStyle}
				placeholder="Enter value here"
				value={MaxValueAllLoc}
				onChange={e => handleChangeInMaxValueAllLoc(e)}
				compulsory
				autoComma
				rupee
			/>
			<Space y={2.5} />
			<Alert
				variant="secondary"
				infoIconColor={theme.colors.secondary}
				titleColor={theme.colors.secondary}
				title="Please enter the maximum value for your stock (from the previous year) for each stock
				location and add it together"
			/>
			<Divider top={2.5} bottom={2.5} />
			<Input
				label="Maximum stock value at any one location:"
				labelStyle={textStyle}
				placeholder="Enter value here"
				value={MaxValueOneLoc}
				onChange={e => handleChangeInMaxValueOneLoc(e)}
				compulsory
				autoComma
				rupee
			/>

			{error ? (
				<>
					<Space y={1.5} />
					<FloaterValuesError />
				</>
			) : null}
			{renderStocSumInsAlert}

			<Modal
				show={modalState}
				handleClose={() => setModalState(false)}
				closeButton={true}
				title={
					<Text type="primary" color={theme.colors.red}>
						Error
					</Text>
				}
				footer={<></>}
				style={{ textAlign: 'center' }}
			>
				{modalContent}
			</Modal>
		</MainContainer>
	)
}

export default FloaterDeclaration2

const textStyle = {
	fontSize: '24px',
	fontWeight: 700,
	color: `${theme.colors.gray7}`,
	marginBottom: '1rem',
}
